document.addEventListener("DOMContentLoaded", function () {
    class UpsellSlider extends HTMLElement {
      constructor() {
        super();
        this.sliderRef = this.querySelector("[data-slider]");
        this.nextRef = this.querySelector('[data-navigation="next"]') || null;
        this.previousRef = this.querySelector('[data-navigation="prev"]') || null;
        this.initSlider = this.initSlider.bind(this);
      }
  
      connectedCallback() {
        this.initSlider();
      }
  
      initSlider() {
        this.swiper = new Swiper(this.sliderRef, {
          // Optional parameters
          loop: false,
          autoplay: false,
          slidesPerView: "auto",
          navigation: {
            nextEl: this.nextRef,
            prevEl: this.previousRef,
          },
        });
      }
  
      disconnectedCallback() {
        this.swiper.destroy();
      }
    }
    customElements.define("upsell-slider", UpsellSlider);
});
  